import React, { useMemo } from 'react';
import { Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { resolveSafetyControlReviewV9Parity } from '../../domain/reportContext/safetyControlReview';
import type { SafetyReportArtifactDetailResponse } from '../../services/reportsApi';

type Props = {
  artifactData: SafetyReportArtifactDetailResponse | null | undefined;
};

export function SafetyControlReviewV9ParitySection({ artifactData }: Props) {
  const parity = useMemo(
    () => resolveSafetyControlReviewV9Parity(artifactData),
    [artifactData],
  );

  if (!parity) {
    return null;
  }

  return (
    <Card sx={{ mb: 3, borderRadius: 3, border: '1px solid #E2E8F0', boxShadow: 'none' }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          Safety Control Review workflow state
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Buyer-ready labels match the customer PDF export for field verification, ownership, and follow-up boundaries.
        </Typography>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          <Chip size="small" label={`Reviewer decision: ${parity.reviewerDecisionStatus}`} />
          <Chip size="small" variant="outlined" label={parity.fieldVerificationStatus} />
          <Chip size="small" variant="outlined" label={`Corrective action: ${parity.correctiveActionStatus}`} />
          <Chip size="small" variant="outlined" label={parity.closureStatus} />
          {parity.privacyRedacted ? (
            <Chip size="small" variant="outlined" label="Privacy-redacted customer PDF" />
          ) : null}
        </Stack>
        {parity.followUpClaimBoundary ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
            {parity.followUpClaimBoundary}
          </Typography>
        ) : null}
      </CardContent>
    </Card>
  );
}
